import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {Ng2PaginationModule} from 'ng2-pagination';

import {PaginationBootstrapComponent} from './pagination-bootstrap.component';

@NgModule({
  imports: [
    CommonModule,
    Ng2PaginationModule,
  ],
  declarations: [
    PaginationBootstrapComponent,
  ],
  exports: [
    PaginationBootstrapComponent,
  ],
})
export class PaginationBootstrapModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pagination-bootstrap/pagination-bootstrap.module.ts